class ProductCompareModal {
  constructor() {
    this.modal = document.getElementById('ProductCompareModal');
    if (!this.modal) return;

    document.body.appendChild(this.modal);
    this.data = JSON.parse(document.getElementById('CompareModalData').textContent);
    this.selects = this.modal.querySelectorAll('[data-slot-select]');
    this.addAllBtn = this.modal.querySelector('#CompareAddAllBtn');
    
    this.initializedPDP = false;
    this.init();
  }

  init() {
    this.populateDropdowns();
    if (this.addAllBtn) this.addAllBtn.disabled = true;

    /* Intercept "The 4-Pack" clicks everywhere — PDP, collection, quick view */
    document.addEventListener('click', (e) => {
      const target = e.target.closest('label, button, .variant-input, .swatch, span');
      if (!target) return;
      if (target.closest('#ProductCompareModal')) return;

      const text = target.textContent.toLowerCase().trim();
      if (text.includes('4-pack') || text === '4 pack' || text === 'the 4-pack') {
        e.preventDefault();
        e.stopImmediatePropagation();

        const radio = target.querySelector('input[type="radio"]') || target.closest('label')?.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;

        const quickViewDialog = target.closest('dialog');
        if (quickViewDialog && quickViewDialog.open) {
          quickViewDialog.classList.add('dialog-closing');
          setTimeout(() => {
            quickViewDialog.close();
            quickViewDialog.classList.remove('dialog-closing');
            this.open();
          }, 300);
        } else {
          this.open();
        }
      }
    }, true);

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-compare-close]')) this.close();
    });

    this.selects.forEach((select, index) => {
      select.addEventListener('change', (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        this.fetchAndRenderProduct(e.target.value, index, selectedOption.dataset.articleHandle);
      });
    });

    this.modal.addEventListener('click', (e) => {
      if (e.target.closest('#CompareAddAllBtn')) {
        this.handleAddAllToCart();
      }
    });
  }

    updateButtonState() {
        if (!this.addAllBtn) return;
        const count = this.modal.querySelectorAll('[data-compare-variant]').length;
        if (count === 4) {
        this.addAllBtn.disabled = false;
        this.addAllBtn.style.opacity = '1';
        this.addAllBtn.style.cursor = 'pointer';
        } else {
        this.addAllBtn.disabled = true;
        this.addAllBtn.style.opacity = '0.3';
        this.addAllBtn.style.cursor = 'not-allowed';
        }
    }

  populateDropdowns() {
    const products = this.data.collection_products || [];
    const options = `<option value="" disabled selected>Select a product...</option>` + 
      products.map(p => `<option value="${p.handle}" data-article-handle="${p.articleHandle}">${p.title}</option>`).join('');
    this.selects.forEach((s, index) => {
      s.innerHTML = options;
      const slot = this.modal.querySelectorAll('[data-slot-content]')[index];
      if (slot) slot.innerHTML = `<div class="compare-modal__placeholder">Select a product</div>`;
    });
    this.updateButtonState();
  }

  open() {
    this.modal.style.display = 'flex';
    if (!this.initializedPDP && this.data.current_product) {
      const firstSelect = this.selects[0];
      firstSelect.value = this.data.current_product;
      this.fetchAndRenderProduct(this.data.current_product, 0, this.data.currentProductArticleLink);
      this.initializedPDP = true;
    }
    setTimeout(() => {
      this.modal.setAttribute('aria-hidden', 'false');
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.style.overflow = 'hidden';
      this.updateButtonState();
    }, 10);
  }

  async fetchAndRenderProduct(handle, slotIndex, aHandle) {
    const slot = this.modal.querySelectorAll('[data-slot-content]')[slotIndex];
    slot.innerHTML = `<div class="compare-modal__placeholder">Loading...</div>`;
    try {
      const root = window.Shopify.routes ? window.Shopify.routes.root : '/';
      const res = await fetch(`${root}products/${handle}.js`);
      if (!res.ok) throw new Error('Fetch failed');
      const prod = await res.json();
      const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      const placeholderImg = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><rect width="400" height="400" fill="#f0f0f0"/><g transform="translate(200,190)" text-anchor="middle" font-family="system-ui,sans-serif" fill="#b0b0b0"><rect x="-28" y="-38" width="56" height="42" rx="3" fill="none" stroke="#b0b0b0" stroke-width="2"/><circle cx="8" cy="-24" r="5" fill="none" stroke="#b0b0b0" stroke-width="2"/><polyline points="-22,-2 -8,-18 4,-6 12,-12 22,-2" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><text y="30" font-size="13">No Image</text></g></svg>')}`;
      const imgSrc = prod.featured_image ? prod.featured_image : placeholderImg;
      slot.innerHTML = `
        <div class="compare-card__image">
          <img src="${imgSrc}" alt="${prod.title}" style="width:100%; aspect-ratio:1/1; object-fit:cover; border-radius:4px; background:#f0f0f0;">
        </div>
        <h3 class="compare-card__title">${prod.title}</h3>
        <!-- <div class="compare-card__price">${formatter.format(prod.price / 100)}</div> -->
        <!-- Variant select is hidden from UI but kept in DOM so handleAddAllToCart() can read [data-compare-variant] -->
        <select class="compare-card__variants" data-compare-variant style="display:none;" data-article-handle="${aHandle}">
          ${prod.variants.filter(v => !/(4-pack|4 pack)/i.test(v.title)).map(v => `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>${v.title}${!v.available ? ' — Sold Out' : ''}</option>`).join('')}
        </select>
      `;
      this.updateButtonState();
    } catch (e) {
      console.error('Compare modal fetch error:', e);
      slot.innerHTML = `<div class="compare-modal__placeholder">Error loading product.</div>`;
      this.updateButtonState();
    }
  }

  async handleAddAllToCart() {
    const variantSelects = this.modal.querySelectorAll('[data-compare-variant]');
    const properties = {};
    let selectionCount = 0;
    let articleLink = null;

    variantSelects.forEach((s, i) => {
      if (s.tagName === 'SELECT' && s.options[s.selectedIndex] && s.options[s.selectedIndex].disabled) return;
      if (s.value) {
        articleLink = s.dataset.articleHandle;
        selectionCount++;
        const productTitle = s.closest('[data-slot-content]')?.querySelector('.compare-card__title')?.textContent?.trim() || `Product ${selectionCount}`;
        const variantTitle = s.options[s.selectedIndex]?.textContent?.trim() || '';
        properties[`Selection ${selectionCount}`] = variantTitle !== 'Default Title' ? `${productTitle} — ${variantTitle}` : productTitle;
        if (articleLink != '' || articleLink != 'undefined') {
          properties[`_article_link_${selectionCount}`] = `${articleLink}`
        }

      }
    });

        if (selectionCount < 4) return;

    const firstSlotImg = this.modal.querySelector('[data-slot-content] img');
    if (firstSlotImg && firstSlotImg.src) properties['_image'] = firstSlotImg.src;


    const fourpackId = this.data.fourpack_variant_id;
    if (!fourpackId) {
      console.error('CompareModal: fourpack_variant_id is null');
      return;
    }

    this.addAllBtn.textContent = 'Adding...';
    this.addAllBtn.disabled = true;

    try {
      const root = window.Shopify.routes ? window.Shopify.routes.root : '/';
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(fourpackId, 10),
            quantity: 1,
            properties: properties
          }]
        })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Add to cart failed');
      }

      this.addAllBtn.textContent = 'Added ✓';
      setTimeout(() => {
        this.close();
        window.location.href = root + 'cart';
      }, 600);

    } catch (err) {
      console.error('Add to cart error:', err);
      this.addAllBtn.textContent = 'Error — Try Again';
      setTimeout(() => {
        this.addAllBtn.textContent = 'Add to Cart';
        this.addAllBtn.disabled = false;
      }, 2000);
    }
  }


  close() {
    this.modal.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      this.populateDropdowns();
      this.initializedPDP = false;
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => { new ProductCompareModal(); });
